import { createContext, useContext, type PropsWithChildren } from "react";

export interface StreetViewConfigContextStore {
  googleMapsApiKey: string;
}

export const StreetViewConfigContext = createContext<StreetViewConfigContextStore | undefined>(undefined);

export const useStreetViewConfig = () => useContext(StreetViewConfigContext);

/*
 * Provides the StreetView configuration to components that need it.
 * Expects server configuration in 'globalThis.serverConfig' (full server scenario).
 * Falls back to STORYBOOK_GOOGLE_MAPS_API_KEY env var for Storybook.
 */
export const StreetViewConfigProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const serverApiKey = (globalThis.serverConfig as StreetViewConfigContextStore | undefined)?.googleMapsApiKey;
  const apiKey = serverApiKey ?? (import.meta.env.STORYBOOK_GOOGLE_MAPS_API_KEY as string | undefined);
  if (!apiKey) {
    console.warn("MapsConfigProvider: no Google Maps API key found. Context is not set.");
    return <>{children}</>;
  }

  return (
    <StreetViewConfigContext.Provider value={{ googleMapsApiKey: apiKey }}>{children}</StreetViewConfigContext.Provider>
  );
};
